import { Navigate } from "react-router-dom";
import { useUserRoles } from "@/hooks/useUserRoles";
import { Loader2 } from "lucide-react";

interface ProtectedEmployerRouteProps {
  children: React.ReactNode;
}

const ProtectedEmployerRoute = ({ children }: ProtectedEmployerRouteProps) => {
  const { data: roles, isLoading } = useUserRoles();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const isEmployer = roles?.includes("employer");

  if (!isEmployer) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedEmployerRoute;
